const { server_ip }= require('../config');

export async function insertNewSchoolMission(token,schoolId,missionId){
    try {
        const response= await fetch(`${server_ip}/api/pschoolMissions`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                schoolId,missionId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchSchoolMissions(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/pschoolMissions/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function updateSchoolMissionById(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api/pschoolMissions/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function deleteSchoolMission(token,id){
    try {
        const response= await fetch(`${server_ip}/api/pschoolMissions/${id}`,{
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherUpdateSchoolMission(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api/pschoolMissions/teacher/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}